import ParameterFieldBase from './ParameterFieldBase';
import RadioGroupFieldComponent, { IRadioGroupFieldOptions } from '../tsx/RadioGroupField';

export class RadioGroupField extends ParameterFieldBase<IRadioGroupFieldOptions> {
    public static defaultValidators = [];
    public static EditComponent = RadioGroupFieldComponent;

    public getDefaultOptions() {
        return {
            items: [],
            displayField: 'text',
            valueField: 'value'
        } as IRadioGroupFieldOptions;
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?: IRadioGroupFieldOptions) {
        super(glob, title, RadioGroupField.defaultValidators, validators, defaultVal, options);
    }
}
